import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: 1,
    title: "PERFORMANCE MARKETING",
    intro:
      "Performance Marketing is the backbone of measurable digital growth and a digital marketing strategy where advertisers pay only when a specific action, like a sale or click, is completed.",
  },
  {
    id: 2,
    title: "SOCIAL MEDIA MARKETING",
    intro:
      "Social media marketing is the process of creating and publishing content on all social media platforms to reach your target audience, promote your products or services, and turn consumers into loyal customers. At Commmmuniti, top marketing agency in Indore, we use strategic content and platform-focused campaigns to build brand awareness, engagement, and business growth.",
  },
  {
    id: 3,
    title: "SEARCH ENGINE OPTIMIZATION",
    intro:
      "Search Engine Optimization is the process of optimizing websites to rank higher on Google and increase organic visibility. It helps drive quality traffic, improve online presence, and support long-term business growth. As part of digital marketing services in Indore, SEO is essential for reaching the right audience without paid ads.",
  },
  {
    id: 4,
    title: "BROCHURE AND INVITE DESIGN",
    intro:
      "We design impactful brochures and event creatives that bring ideas to life. From wedding invites and birthday designs to menus, standees, and event collaterals, we create visuals that are both functional and visually engaging.",
  },
  {
    id: 5,
    title: "BRAND STRATEGY",
    intro:
      "A strong brand strategy aligns your branding and marketing strategy, creating a clear identity, consistent messaging, and meaningful customer connections that fuel business growth.",
  },
  {
    id: 6,
    title: "WEBSITE DESIGN",
    intro:
      "Your website is your brand's digital home. At Commmmuniti, the best digital marketing agency in Indore, we create website designs that build trust, drive engagement, and accelerate business growth.",
  },
  {
    id: 7,
    title: "EVENT MANAGEMENT",
    intro:
      "Event hosting is the end-to-end process of planning, managing, and executing impactful events like conferences, brand launches, and corporate gatherings. We focus on creating seamless experiences through strong concept development, creative execution, and precise on-ground coordination.",
  },
  {
    id: 8,
    title: "ACCOUNTING & ADVISORY SERVICES",
    intro:
      "Complete bookkeeping and accounting services to keep your finances organized and up-to-date and Strategic financial guidance to help you make informed decisions for your business growth.",
  },
];

export default function Expertise() {
  const [open, setOpen] = useState(1);

  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="relative text-white py-16 lg:py-24 overflow-hidden"
      style={{ backgroundColor: "#0d3a6e" }}
    >
      {/* Centered eyebrow + headline */}
      <div className="relative mx-auto max-w-[1440px] px-6 lg:px-10 text-center pb-16 lg:pb-24">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="label-eyebrow-light"
        >
          What We Do
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
           className="mt-5 font-display text-4xl sm:text-5xl lg:text-7xl tracking-tight"
        >
          OUR{" "}
          <span className="font-serif-it" style={{ color: "#9ca3af" }}>
            expertise
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-6 max-w-3xl mx-auto text-sm sm:text-base text-white/80 leading-relaxed"
        >
          We help brands become their best version by building authentic
          identities and meaningful digital experiences. Every challenge is
          unique, and so is our approach. At Commmmuniti, which is recognised as
          the best Google Ads Agency in Indore, we act as growth partners
          focused on consistent impact and long-term success.
        </motion.p>
      </div>

      {/* Full-width accordion */}
      <div className="relative mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-10">
        <div className="rounded-[28px] border border-white/15 bg-white/[0.04] backdrop-blur-sm overflow-hidden">
          {SERVICES.map((s, idx) => {
            const isOpen = s.id === open;
            return (
              <div
                key={s.id}
                data-testid={`accordion-row-${s.id}`}
                className={`border-t border-white/15 ${idx === 0 ? "border-t-0" : ""}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? 0 : s.id)}
                  data-testid={`accordion-toggle-${s.id}`}
                  className="group w-full text-left px-6 sm:px-12 py-7 sm:py-9 flex items-center justify-between gap-6"
                >
                   <div className="flex items-baseline gap-6 sm:gap-10 min-w-0 flex-1">
                     <span
                       className={`shrink-0 font-display text-sm sm:text-base md:text-xl ${isOpen ? "text-[#e6e6e6]" : "text-white/45"}`}
                     >
                       0{s.id}
                     </span>
                         <span
                            className={`font-display tracking-[-0.02em] text-[5vw] sm:text-[3vw] md:text-[2.3vw] leading-[0.9] ${isOpen ? "text-white" : "text-outline text-outline-hover"}`}
                         >
                       {s.title}
                     </span>
                   </div>
                  <motion.span
                     animate={{ rotate: isOpen ? 45 : 0 }}
                     transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                     className={`shrink-0 inline-flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full border ${
                       isOpen
                         ? "border-black text-black bg-white"
                         : "border-white/30 text-white/70 group-hover:border-white/80"
                     }`}
                   >
                      <ArrowUpRight className="h-4 w-4 sm:h-5 sm:w-5" />
                   </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 sm:px-12 pb-10 lg:pb-14">
                        <div className="max-w-4xl ml-0 sm:ml-[68px]">
                          <p className="text-xs uppercase tracking-[0.22em] text-white/70">
                            Overview
                          </p>
                          <p className="mt-4 text-base lg:text-lg leading-relaxed text-white/90">
                            {s.intro}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
